import { useQueryResourceDetail } from './useQueryResourceDetail.js';
import { isResourceDetailFolder } from '../utils/resourceDetailGuards.js';
import React__default from 'react';

const useQueryFolder = (params, queryOptions) => {
  const queryResourceDetail = useQueryResourceDetail(params, {
    ...queryOptions,
    onFetchSuccess: (resource) => {
      if (!isResourceDetailFolder(resource)) {
        throw new Error("Resource is not a folder");
      }
    }
  });
  const folder = React__default.useMemo(() => {
    if (queryResourceDetail.resource?.kind === "folder") {
      return queryResourceDetail.resource;
    }
    return null;
  }, [
    queryResourceDetail.resource
  ]);
  return {
    ...queryResourceDetail,
    folder
  };
};

export { useQueryFolder };
//# sourceMappingURL=useQueryFolder.js.map
